import type { LoggedUserDTO } from '@justomx/webview-commons'
import { loginClientByPassword, loginClientByQR } from './user.client'
import type { Country } from '../../internal-types/country.type'

export const loginUserService = async (
  value: string,
  country: Country
): Promise<LoggedUserDTO> => {
  const loginResponse = await loginClientByQR(value, country)
  if (loginResponse.version === 'v1') {
    return loginResponse
  }

  return {
    country,
    authorizationCore:
      loginResponse.user?.saleorAuth?.data?.tokenCreate?.token ||
      loginResponse.token,
    authorizationWms: loginResponse.token,
    authorization: loginResponse.token,
    warehouse: loginResponse.user.warehouse.name,
    firstName: loginResponse.user.firstName || '.',
    lastName: loginResponse.user.lastName || '.',
    username: loginResponse.user.username || loginResponse.username,
    roles: [],
    menuItems: loginResponse.menuItems || []
  }
}

export const loginUserPasswordService = async (
  username: string,
  password: string,
  country: Country
): Promise<LoggedUserDTO> => {
  const loginResponse = await loginClientByPassword({
    username,
    password,
    country
  })

  return {
    country,
    authorizationCore:
      loginResponse.user?.saleorAuth?.data?.tokenCreate?.token ||
      loginResponse.token,
    authorizationWms: loginResponse.token,
    authorization: loginResponse.token,
    refreshToken: loginResponse.refreshToken,
    warehouse: loginResponse.user.warehouse.name,
    firstName: loginResponse.user.firstName || '.',
    lastName: loginResponse.user.lastName || '.',
    username: loginResponse.username,
    roles: [],
    menuItems: loginResponse.menuItems || []
  }
}
